<template>
    <NodeViewWrapper ref="customTagsAndFieldsTrigger" as="span">
        <span
            :tag="tag"
            :class="classes"
            :draggable="isDraggable"
            data-drag-handle
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
            @focus="handleFocus"
            @blur="handleBlur"
        >
            <CompassIcon v-if="showDragIcon" icon="ai-drag-plan" size="extra-small" />
            <span class="typographies-paragraph-small-bold">
                {{ label }}
            </span>
        </span>
    </NodeViewWrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3';

export default {
    components: {
        NodeViewWrapper,
    },
    props: {
        // (Tiptap) used to pass the nodeView props to the NodeViewWrapper (CustomTagFields.js)
        // eslint-disable-next-line vue/no-unused-properties
        nodeViewProps,
    },
    computed: {
        type() {
            return this.node.attrs.type;
        },
        label() {
            return this.node.attrs.label;
        },
        tag() {
            return this.node.attrs.tag;
        },
        isDraggable() {
            if (this.isDisabled) {
                return false;
            }
            return this.node.attrs.isDraggable;
        },
        isHovered() {
            return this.node.attrs.isHovered;
        },
        isFocused() {
            return this.node.attrs.isFocused;
        },
        isDisabled() {
            return this.node.attrs.isDisabled;
        },
        showDragIcon() {
            return (this.isHovered || this.isFocused) && this.isDraggable;
        },
        classes() {
            // style is on "__richtext.scss" (styleguide)
            return [
                'custom-tags-and-fields',
                `custom-tags-and-fields__${this.type}`,
                this.isHovered && this.isDraggable
                    ? `custom-tags-and-fields__${this.type}--hovered`
                    : '',
                this.isFocused && this.isDraggable
                    ? `custom-tags-and-fields__${this.type}--focused`
                    : '',
            ];
        },
    },
    mounted() {
        // update the node attributes (props from CustomTagFields.js)
        this.updateNodeAttributes({
            type: this.type,
            label: this.label,
            tag: this.tag,
            isDraggable: this.isDraggable,
            isHovered: this.isHovered,
            isFocused: this.isFocused,
            isDisabled: this.isDisabled,
        });
    },
    methods: {
        handleMouseOver() {
            if (!this.isDraggable) {
                return;
            }
            this.updateNodeAttributes({ isHovered: true });
        },
        handleMouseLeave() {
            this.updateNodeAttributes({ isHovered: false, isFocused: false });
        },
        handleFocus() {
            if (!this.isDraggable) {
                return;
            }
            this.updateNodeAttributes({ isFocused: true });
        },
        handleBlur() {
            this.updateNodeAttributes({ isHovered: false, isFocused: false });
        },
        updateNodeAttributes(attrs) {
            if (this.isDisabled) {
                return;
            }
            this.updateAttributes(attrs);
        },
    },
};
</script>
